import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export type PillStatus = "default" | "active" | "error" | "disabled";

const pillBackgroundColor: Record<PillStatus, string> = {
  disabled: theme.colors.white,
  default: theme.colors.grey_6,
  active: theme.colors.purple_2,
  error: theme.colors.red_2,
};

const pillBorderColor: Record<PillStatus, string> = {
  disabled: theme.colors.grey_4,
  default: theme.colors.grey_5,
  active: theme.colors.purple_2,
  error: theme.colors.red_2,
};

export const StyledPill = styled.div<{ $status: PillStatus }>`
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: ${({ $status }) => pillBackgroundColor[$status]};
  border-radius: ${theme.variables.border_radius_6};
  border: 1px solid ${({ $status }) => pillBorderColor[$status]};
  padding: 5px 12px;
  white-space: nowrap;
  cursor: default;
`;
